<template>
	<div>
		<buttonlist @add="add" @search="search" @reflash="reflash" @save="save" ref="SetBtn"></buttonlist>

		<el-table
			id="xpane-0"
			:data="dataSet"
			:highlight-current-row="false"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			header-row-class-name="headerclass"
			:height="tableHeight"
			tab-click="selectInfo(0)"
			style="width: 100%; margin-top:0px"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Login_DB" :label="$t('getapi[12488]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Login_Group" :label="$t('getapi[12489]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Login_DB_View" :label="$t('getapi[7981]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="User_Login_Code" :label="$t('getapi[12385]')"></el-table-column>
			<!--<el-table-column show-overflow-tooltip prop="User_Login_Pwd" :label="$t('getapi[3]')"></el-table-column>-->
			<el-table-column show-overflow-tooltip prop="User_Name" :label="$t('getapi[5]')"></el-table-column>
			<el-table-column show-overflow-tooltip fixed="right" :label="$t('getapi[6048]')" width="100">
				<template slot-scope="scope">
					<el-button @click.native.prevent="editInfo(scope)" type="text" size="small">{{$t('getapi[34]')}}</el-button>
					<el-popconfirm :confirmButtonText="$t('getapi[6109]')" :cancelButtonText="$t('getapi[6851]')" icon="el-icon-info" iconColor="red" :title="$t('getapi[6049]')" @onConfirm="del(scope)">
						<el-button slot="reference" type="text" size="small">{{$t('getapi[40]')}}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[12487]')" width="31%" :close-on-click-modal="false">
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[7981]')}}</td>
					<td>
						<el-select v-model="formInline.Login_DB_View" @change="getInstanceName" class="select" :disabled="addoredit == 2">
							<el-option v-for="item in apiData" :key="item.Login_Name" :label="item.Login_Name"
									   :value="item"></el-option>
						</el-select>
					</td>
					<td>{{$t('getapi[12488]')}}</td>
					<td><el-input v-model="formInline.Login_DB" type="text" size="mini" :disabled="true"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[12489]')}}</td>
					<td><el-input v-model="formInline.Login_Group" type="text" size="mini" :disabled="true"></el-input></td>
					<td>{{$t('getapi[12385]')}}</td>
					<td><el-input v-model="formInline.User_Login_Code" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3]')}}</td>
					<td><el-input v-model="formInline.User_Login_Pwd" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[5]')}}</td>
					<td><el-input v-model="formInline.User_Name" type="text" size="mini" :disabled="true"></el-input></td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button size="small"  @click="editvisi = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small"  type="primary" @click="confirmAdd">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>
		<!-- 编辑弹框 -->
	</div>
</template>

<script>
import Common from '@/components/Common';
import axios from 'axios';
import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'
export default {
	name: 'multipledb',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight2
        }
    },
	data() {
		return {
			formInline: {
                Exclusively_ID:'',
                Login_DB:'',
                Login_Group:'',
                Login_DB_View:'',
                User_Login_Code:'',
                User_Login_Pwd:'',
                User_Name:''
			},
			editvisi: false,
            dataSet:[],
			addoredit: 1,//1:新增2：编辑
            apiData:[],
            rowindex: -1,
		};
	},
	create() {},
	beforeMount() {
	},
    watch: {
        datajson: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted() {
		let that = this;
		that.getApiData()
		that.intidata();
		that.authority();
	},
	methods: {
		authority() {
			let that = this;
            that.$refs.SetBtn.SetButtonEnable('create,search,refresh,save');
		},
        getApiData() {
            let that = this;
            axios
                .post(Common.Url + 'Basic/GetApiData', {})
                .then(function (res) {
                    let reqdata = res.data;
                    that.apiData = reqdata.DataContent;
                })
                .catch(function (error) {
                    that.$message.error('错误提示: ' + error);
                });
        },
        getInstanceName(val){
		    let that = this
			console.log(val)
            that.formInline.Login_DB= val.Login_DB;
            that.formInline.Login_Group= val.Login_Group;
            that.formInline.Login_DB_View = val.Login_Name;
        },
		editInfo(row) {
			let that = this;
			that.rowindex = row.$index
            that.addoredit = 2
            this.formInline.Exclusively_ID= row.row.Exclusively_ID;
            this.formInline.Login_DB= row.row.Login_DB;
            this.formInline.Login_Group= row.row.Login_Group;
            this.formInline.Login_DB_View = row.row.Login_DB_View;
            this.formInline.User_Login_Code = row.row.User_Login_Code;
            this.formInline.User_Login_Pwd = row.row.User_Login_Pwd;
            this.formInline.User_Name = row.row.User_Name;
            this.editvisi = true;
		},
		// 获取数据
		intidata() {
			let that = this;
			/*const key = generatekey(8)
            that.dataSet = JSON.parse(sessionStorage.getItem('dbinfo')).DBinfo
			for(let i = 0;i<that.dataSet.length;i++){
                that.dataSet[i].User_Login_Pwd = decryptDes(that.dataSet[i].User_Login_Pwd, key)
			}*/
            let parm = {}
            that.$http.urlpost('/User/SYS_Users/MListQuery', parm, function(res) {
                if (res.Success == 1) {
                    that.dataSet = res.DataContent
                }
            });
		},
		save() {
			let that = this;
			let parm = that.dataSet
			that.$http.urlpost('/User/SYS_Users/MListEidt', parm, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
				}
			});
		},
		add() {
			let that = this;
			that.editvisi = true;
			that.addoredit = 1
			that.formInline = {
                Exclusively_ID:'',
                Login_DB:'',
                Login_Group:'',
                Login_DB_View:'',
                User_Login_Code:'',
                User_Login_Pwd:'',
                User_Name:JSON.parse(sessionStorage.getItem('userData')).username
			};
		},
        confirmAdd(){
		    let that = this
			if(that.addoredit == 1){
                for(let i = 0;i<that.dataSet.length;i++){
					if(that.formInline.Login_DB == that.dataSet[i].Login_DB){
					    that.$message.warning(that.$t('getapi[12490]'))
					    return false
					}
                }
                that.dataSet.push({
                    Exclusively_ID: this.formInline.Exclusively_ID,
                    Login_DB:this.formInline.Login_DB,
                    Login_Group:this.formInline.Login_Group,
					Login_DB_View:this.formInline.Login_DB_View,
					User_Login_Code:this.formInline.User_Login_Code,
					User_Login_Pwd:this.formInline.User_Login_Pwd,
                    User_Name:this.formInline.User_Name,
				})
			} else {
                that.dataSet[that.rowindex].Exclusively_ID= this.formInline.Exclusively_ID
                that.dataSet[that.rowindex].Login_DB=this.formInline.Login_DB
                that.dataSet[that.rowindex].Login_Group=this.formInline.Login_Group
                that.dataSet[that.rowindex].Login_DB_View=this.formInline.Login_DB_View
                that.dataSet[that.rowindex].User_Login_Code=this.formInline.User_Login_Code
                that.dataSet[that.rowindex].User_Login_Pwd=this.formInline.User_Login_Pwd
                that.dataSet[that.rowindex].User_Name=this.formInline.User_Name
			}
            that.editvisi = false
		},
        del(row){
		    let that = this
		  	that.dataSet.splice(row.$index,1)
		},
        search(){
            this.intidata();
		},
		reflash() {
			this.intidata();
		},
	}
};
</script>

<style lang="scss" scoped>

table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
